<template>
  <div>
    <MglMarker 
      style="display:none"
      ref="marker"
      :coordinates="coordinates">
      <MglPopup :offset="offset" @close="handleClosePopup">
        <div>
          <p v-if="activeMarkerId && ! editingMarker">
            {{ PopupLabel }} <br />
            ID: {{ activeMarkerId }}
            <template v-if="userName">
              <br/>
              <span class="text-muted">{{ userName }}</span>
            </template>
            <template v-if="PopupRemark">
              <br /><br />
              {{ PopupRemark }}
            </template>
            <template v-if="canRemove">
              <br/>
              <b-button 
                class="mt-2" 
                size="sm" 
                variant="primary" 
                @click="handleStartEdit">
                Bewerken
              </b-button>
              <b-button 
                class="mt-2 ml-2" 
                size="sm" 
                variant="danger" 
                @click="handleRemove">
                Remove
              </b-button>
            </template>
            <template v-else>
              <br />
              <b-button 
                class="mt-2" 
                size="sm" 
                variant="light" 
                @click="handleStartEdit">
                Opmerking
              </b-button>
            </template>
          </p>
          <div v-else-if="editingMarker">
            <Form @submit="handleSubmitUpdate">
              <FormField 
                v-model="field.value"
                v-bind="field" />
              <FormField 
                v-model="remark.value"
                v-bind="remark" />
              <FormField 
                v-if="canChangeStatus"
                v-model="status.value"
                v-bind="status" />
              <b-button 
                type="submit"
                class="mt-2" 
                size="sm" 
                variant="primary">
                Opslaan
              </b-button>
              <b-button 
                type="button"
                class="mt-2 ml-2" 
                size="sm" 
                @click="handleCloseEdit"
                variant="light">
                annuleren
              </b-button>
            </Form>
          </div>
          <div v-else>
            <Form @submit="handleSubmitAdd">
              <FormField 
                v-model="field.value"
                v-bind="field" />
              <FormField 
                v-model="remark.value"
                v-bind="remark" />
              <FormField 
                v-if="canChangeStatus"
                v-model="status.value"
                v-bind="status" />
              <b-button 
                type="submit"
                class="mt-2" 
                size="sm" 
                variant="primary">
                Toevoegen
              </b-button>
            </Form>
          </div>
        </div>
      </MglPopup>
      <template slot="marker">
        <div v-show="showMarker"></div>
      </template>
    </MglMarker>
  </div>
</template>

<script>
/* eslint-disable */

// import mapboxgl from 'mapbox-gl'
import { MglPopup, MglMarker } from 'vue-mapbox'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import { required } from 'vuelidate/lib/validators'

import { isPlanModeAdmin, isAnalist } from 'service/auth'
import { image } from 'helper/assets'

import { activateUserClient, activateAnalistClient } from 'service/faunadb'

export default {
  name: 'ChargingPointPlanner',
  components: { 
    MglPopup, MglMarker, Form, FormField
  },
  data() {
    return {
      active: false,
      showMarker: false,
      coordinates: [4.599175453588543, 51.914311573958],
      PopupLabel: '',
      PopupRemark: '',
      activeMarkerId: null,
      userName: '',
      offset: 0,
      field: {
        label: 'Label',
        value: '',
        validationRules: {
          required
        }
      },
      remark: {
        label: 'Opmerking',
        value: '',
        type: 'textarea'
      },
      status: {
        label: 'Status',
        value: '',
        type: 'select',
        options: [{
          value: 'suggestion',
          text: 'Suggestie'
        }, {
          value: 'definitive',
          text: 'Definitief'
        }, { 
          value: 'in-progress',
          text: 'In voorbereiding'
        }, {
          value: 'realized',
          text: 'Gerealiseerd'
        }, {
          value: 'alert',
          text: 'Aandachtspunt'
        }]
      },
      points: [],
      draggingPoint: null,
      editingMarker: false
      // [{
      //   "coordinates": [4.599175453588543, 51.914311573958],
      //   "properties": {
      //     "id": 1,
      //     "label" : 'Hello there'
      //   },
      // }]
    }
  },
  computed: {
    ...mapGetters('map', [
      'getLoadedStatus',
      'getSymbolLayerId',
      'getEditMode',
      'getLocations'
    ]),
    ...mapGetters('user', [
      'user'
    ]),
    canRemove() {
      return this.getEditMode && (isPlanModeAdmin() || (isAnalist() && (this.userName === this.currentUserName) && (this.status.value !== 'definitive')))
    },
    canChangeStatus() {
      return isPlanModeAdmin()
    },
    currentUserName() {
      return this.user ? this.user.name : 'Anoniem'
    }
  },
  watch: {
    getLoadedStatus(value) {
      if (value) {
        this.setup()
      }
    },
    points(value) {
      let source = this.$store.map.getSource('plannedchargingpoints')
      if (source) {
        source.setData(this.generateGeoJson(value))
      }
    },
    getLocations(value) {
      this.points = value
    }
  },
  mounted() {
    if (this.getLoadedStatus) {
      this.setup()
    }
  },
  methods: {
    ...mapActions('map', [
      'getChargingLocations',
      'addChargingLocation',
      'updateChargingLocation',
      'deleteChargingLocation'
    ]),
    ...mapMutations('map', [
      'setLayerAvailability'
    ]),
    image,
    setup() {
      if (this.active) {
        return
      }
      this.active = true

      activateUserClient({ key: process.env.VUE_APP_FAUNADB_KEY })
      
      this.getChargingLocations()
      this.addPlanLayer()
      this.$store.map.on('click', 'plannedchargingpoints', this.handleClickMarkerEvent)

      // Cursor
      this.$store.map.on('mouseenter', 'plannedchargingpoints', () => {
        this.$store.map.getCanvas().style.cursor = 'pointer'
      })
      this.$store.map.on('mouseleave', 'plannedchargingpoints', () => {
        this.$store.map.getCanvas().style.cursor = ''
      })

      // Editing mode setup & event hooks
      if ((isPlanModeAdmin() || isAnalist()) && this.user && this.user.faunaKey) {
        activateAnalistClient({ key: this.user.faunaKey })

        // if (isPlanModeAdmin()) {
          this.$store.map.on('click', this.handleAddMarkerEvent)

          // Dragging
          this.$store.map.on('mousedown', 'plannedchargingpoints', (e) => {
            if (! this.getEditMode) return

            // Prevent the default map drag behavior.
            e.preventDefault()
            
            this.$store.map.getCanvas().style.cursor = 'grab'
            
            this.$store.map.on('mousemove', this.handleMove)
            this.$store.map.once('mouseup', this.handleUp)
          })
          this.$store.map.on('touchstart', 'plannedchargingpoints', (e) => {
            if (e.points.length !== 1 || ! this.getEditMode) return
            
            // Prevent the default map drag behavior.
            e.preventDefault()
            
            this.$store.map.on('touchmove', this.handleMove)
            this.$store.map.once('touchend', this.handleUp)
          })
        // }
      }

      this.points = this.getLocations || []
    },
    /**
     * Show the label & ID of the Charging point
     */
    handleClickMarkerEvent(e) {
      // Hack to stop the event that adds a new marker
      // Because e.originalEvent.stopPropagation() does not work
      e.preventDefault()
      e.originalEvent.stopPropagation()
      
      if (!e.features.length) {
        return // to be sure
      }

      this.PopupLabel = e.features[0].properties.label
      this.PopupRemark = e.features[0].properties.remark || ''
      this.activeMarkerId = e.features[0].properties.id
      this.userName = e.features[0].properties.user_name || 'EV Consult'
      this.status.value = e.features[0].properties.status || 'definitive'

      this.coordinates = e.lngLat.toArray()
      this.$refs.marker.togglePopup()
    },
    handleMove(e) {
      if (e._defaultPrevented || ! this.getEditMode) {
        return
      }
      
      // Only admins & consultants may move a point
      if (! isPlanModeAdmin() && !isAnalist()) {
        return
      }
      
      let features = this.$store.map.queryRenderedFeatures(e.point, {
        layers: ['plannedchargingpoints']
      })

      // if not already dragging a point, and no feature is at the cursor, exit
      if (this.draggingPoint === null && features.length === 0) {
        return null
      }
      
      // store the point being dragged
      if (this.draggingPoint === null) {
        this.draggingPoint = this.points.find(point => point.properties.id === features[0].properties.id)
      }
      // non admins may only edit their own points
      if (
          ! isPlanModeAdmin() && 
          (this.currentUserName !== this.draggingPoint.properties.user_name ||
          this.draggingPoint.properties.status === 'definitive')
        ) {
        return
      }

      // Set a UI indicator for dragging.
      this.$store.map.getCanvas().style.cursor = 'grabbing'

      // Note that we're updating the dataset without persisting the location
      // persisting occurs when the user lets go of the marker
      let coords = e.lngLat
      this.draggingPoint.coordinates = [coords.lng, coords.lat]
      this.$store.map
        .getSource('plannedchargingpoints')
        .setData(this.generateGeoJson(this.points))
      
    },
    
    handleUp(e) {
      this.$store.map.getCanvas().style.cursor = ''

      // Persist once the user lets go of the marker
      if (this.draggingPoint) {
        this.updateChargingLocation({ 
          ref: this.draggingPoint.ref, 
          label: this.draggingPoint.properties.label, 
          id: this.draggingPoint.properties.id, 
          userName: this.draggingPoint.properties.user_name, 
          status: this.draggingPoint.properties.status,
          remark: this.draggingPoint.properties.remark,
          coordinates: this.draggingPoint.coordinates 
        })
      }

      this.draggingPoint = null
      
      // Unbind mouse/touch events
      this.$store.map.off('mousemove', this.handleMove)
      this.$store.map.off('touchmove', this.handleMove)
    },
    /**
     * Show the form to add a charging point
     */
    handleAddMarkerEvent(e) {
      if (e._defaultPrevented || ! this.getEditMode) {
        return
      }
      // Only admins & consultants may add a point
      if (! isPlanModeAdmin() && !isAnalist()) {
        return
      }
      this.activeMarkerId = null
      this.PopupLabel = 'Add new marker'
      this.coordinates = e.lngLat.toArray()
      this.showMarker = true
      this.$refs.marker.togglePopup()
    },
    /**
     * Automatically hide the marker when the popup is closed
     */
    handleClosePopup() {
      this.editingMarker = false
      this.showMarker = false
    },
    /**
     * Remove the marker from the data set
     */
    handleRemove() {
      this.$bvModal.msgBoxConfirm(
        'Bevestig het verwijderen van dit punt.', {
          okVariant: 'danger',
          okTitle: 'Bevestigen',
          cancelTitle: 'Annuleren'
        })
        .then(confirmed => {
          if (confirmed) {
            let point = this.points.find(point => point.properties.id === this.activeMarkerId)
            this.deleteChargingLocation({ ref: point.ref })
            this.$refs.marker.togglePopup()
          }
        })
    },

    handleStartEdit() {
      let point = this.points.find(point => point.properties.id === this.activeMarkerId)
      this.field.value = point.properties.label
      this.remark.value = point.properties.remark || ''
      this.status.value = point.properties.status || (isPlanModeAdmin() ? 'definitive' : 'suggestion')
      
      if (
        !this.getEditMode || 
        ( ! isPlanModeAdmin() && this.currentUserName !== point.properties.user_name) || 
        ( ! isPlanModeAdmin() && this.status.value === 'definitive')
      ) {
        this.field.class = 'd-none'
        this.status.class = 'd-none'
      }

      this.editingMarker = true
    },
    handleCloseEdit() {
      this.field.class = ''
      this.editingMarker = false
    },
    async handleSubmitUpdate() {
      let point = this.points.find(point => point.properties.id === this.activeMarkerId)
      point.properties.label = this.field.value
      point.properties.remark = this.remark.value

      let status = !isPlanModeAdmin() ? point.properties.status : this.status.value
      point.properties.status = status

      await this.updateChargingLocation({ 
        ref: point.ref, 
        label: this.field.value, 
        id: point.properties.id, 
        userName: point.properties.user_name, 
        status: status,
        remark: this.remark.value,
        coordinates: point.coordinates 
      })

      this.PopupLabel = this.field.value
      this.PopupRemark = this.remark.value

      this.$store.map
        .getSource('plannedchargingpoints')
        .setData(this.generateGeoJson(this.points))

      this.editingMarker = false
    },
    /**
     * 
     */
    handleSubmitAdd() {
      let id = 1
      if (this.points.length) {
        id = this.points[this.points.length -1].properties.id + 1
      }

      let status = !isPlanModeAdmin() ? 'suggestion' : this.status.value

      this.addChargingLocation({
        label: this.field.value,
        id,
        userName: this.currentUserName,
        status: status,
        remark: this.remark.value,
        coordinates: this.coordinates,
      })

      this.$refs.marker.togglePopup()
    },
    /**
     * Translate datapoints into GeoJSON
     */
    generateGeoJson(points) {
      let geoJson = {
        "type": "FeatureCollection",
        "features": []
      }

      points.forEach(point => {
        geoJson.features.push({
          "type": "Feature",
          "properties": point.properties,
          "geometry": {
            "type": "Point",
            "coordinates": point.coordinates
          }
        })
      })

      return geoJson
    },
    /**
     * 
     */
    addPlanLayer() {

      let source = this.$store.map.getSource('plannedchargingpoints')
      if (source) {
        this.$store.map.removeLayer('plannedchargingpoints')
        this.$store.map.removeSource('plannedchargingpoints')
      }
      
      this.$store.map.addSource('plannedchargingpoints', {
        type: 'geojson',
        data: this.generateGeoJson(this.points) 
      })

      if (!this.$store.map.hasImage('chargingstation-gemeente')) {
        this.$store.map.loadImage(this.image({ name: 'chargingstation-gemeente.svg' }), function(error, image) {
          this.$store.map.addImage('chargingstation-gemeente')
        })
      }

      this.$store.map.addLayer({ 
        "id": "plannedchargingpoints",
        "type": "symbol",
        "source": "plannedchargingpoints",
        "minzoom": 10,
        "layout": {
          "symbol-placement": "point",
          "symbol-z-order": "source",
          "icon-allow-overlap": true,
          "icon-image": ["match", 
            ['get', 'status'], 
            "definitive", "chargingstation",
            "in-progress", 'chargingstation-inprogress',
            "realized", 'chargingstation2-bestaand',
            "alert", 'chargingstation-alert', 
            "chargingstation-gemeente"],
          "icon-size": 0.8
        },
        "paint": {
          // "icon-color": "",
          "icon-opacity": [ // transition based on zoom
            "interpolate",
            ["linear"],
            ["zoom"],
            10,
            0,
            10.2,
            0.8
          ] 
        }
      }, this.getSymbolLayerId)
      this.setLayerAvailability({ loaded: 'plannedchargingpoints', status: true })
    }

  }
}


</script>

<style lang="scss">
.mapboxgl-marker {
  height: 20px;
  width: 20px;
  z-index: 5;
  // border: 1px solid black;
  border-radius: 50%;
  // background-color: #305bad;
}
.mapboxgl-popup-content {
  padding: 10px 20px 10px 10px !important;

  p {
    margin: 0;
    user-select: auto;
  }
}
</style>